import {copyToClipboard} from './clipboard';

/** Default duration (ms) a "Copied" indicator stays on before it resets. */
export const COPY_FEEDBACK_RESET_MS = 6000;

/**
 * Copies {@code value} to the clipboard and drives a transient "copied" indicator: on success sets
 * {@code copiedFlags[key]} to true, then back to false after {@code resetMs} (cancelling any prior pending reset
 * tracked in {@code resetTimers}); on failure calls {@code onError}. Callers retain {@code resetTimers} so they can
 * clear all pending resets when the component is destroyed.
 */
export function copyWithFeedback<K extends string | number>(
    value: string,
    key: K,
    copiedFlags: Record<K, boolean>,
    resetTimers: Record<K, ReturnType<typeof setTimeout>>,
    onError: () => void,
    resetMs: number = COPY_FEEDBACK_RESET_MS): void
{
    copyToClipboard(value)
        .then(() =>
        {
            copiedFlags[key] = true;
            clearTimeout(resetTimers[key]);
            resetTimers[key] = setTimeout(() => copiedFlags[key] = false, resetMs);
        })
        .catch(onError);
}
